import { GlobalSearchCategory, chipOptions } from "@ubif/types";

/**
 * A complete serial as stored in F&O. Either a store serial (a 4 to 6 digit item SKU, a dash, then
 * 10 digits), optionally with a one letter prefix such as "B-" for buyback, or a buyback distro
 * label ("I-" then 10 digits).
 */
export const FULL_SERIAL_PATTERN = /^(?:[Ii]-\d{10}|(?:[A-Za-z]-)?\d{4,6}-\d{10})$/;

/**
 * Whether quick-search should skip the serial number lookup.
 * The lookup is an exact match against F&O, so it only runs once the input looks like a full
 * serial. Partial input and free text would only come back as "not a valid serial" errors.
 */
export const shouldSkipSerialSearch = (
  searchCategory: GlobalSearchCategory,
  debouncedSearchCriteria: string | undefined
): boolean =>
  searchCategory !== chipOptions.serial_numbers.searchCategory ||
  !FULL_SERIAL_PATTERN.test(debouncedSearchCriteria?.trim() ?? "");
